import React, { FC } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyAnswerDto } from '@families-link/shared';
import { SurveyAnswerRender } from './survey-answer.component';

export type SurveyResultsAnswerListProps = {
	surveyAnswer?: SurveyAnswerDto;
};

export const SurveyResultsAnswerList: FC<SurveyResultsAnswerListProps> = ({ surveyAnswer }) => {
	const [t] = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				flexGrow: 1,
				width: '100%',
			}}
		>
			<Typography variant="h2" sx={{ fontSize: '16px', fontWeight: 500, my: '24px' }}>
				{t('surveys.survey-results')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				{surveyAnswer?.answers?.map((answer, index) => (
					<SurveyAnswerRender answer={answer} order={index + 1} />
				))}
			</Box>
		</Box>
	);
};
